import React, { useRef } from "react";
import "../Job.css";
import { useVisibilityOnScroll } from "../../../Component/Hooks/useVisibilityOnScroll/useVisibilityOnScroll";
import VisibilitySection from "../../../Component/Hooks/useVisibilityOnScroll/VisibilitySection";
import TC3L from "../../../Component/ReuseComponent/TCLines/TC3L";
import ArrowBlue from "../../../Assets/Svg/Header/ArrowBlue.svg";
import JobsForm from "../JobsForm";

export default function JobContainer({ JobData }) {
  const { sectionsRef, visibilityStates } = useVisibilityOnScroll();
  const jobData = JobData[0];
  const jobsS5Ref = useRef(null);

  const handleScrollToJobsS5 = () => {
    jobsS5Ref.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="JobsContainer">
      <section>
        <JobsS1
          JobName={jobData.JobName}
          JobLocation={jobData.JobLocation}
          JobType={jobData.JobType}
          JobDepartment={jobData.JobDepartment}
          onScrollToForm={handleScrollToJobsS5}
        />
      </section>
      <VisibilitySection index={1} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS2">
        <JobsS2 JobH1={jobData.JobH1} JobH1Data={jobData.JobH1Data} />
      </VisibilitySection>
      <VisibilitySection index={2} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS3">
        <JobsS3 JobH2={jobData.JobH2} JobH2Data={jobData.JobH2Data} />
      </VisibilitySection>
      <VisibilitySection index={3} sectionsRef={sectionsRef} visibilityStates={visibilityStates} className="JobsS4">
        <JobsS4 JobH4={jobData.JobH4} JobH4Data={jobData.JobH4Data} />
      </VisibilitySection>
      <section ref={jobsS5Ref} className="">
        <JobsS5 />
      </section>
    </div>
  );
}

function JobsS1({ JobName, JobLocation, JobType, JobDepartment, onScrollToForm }) {
  return (
    <div className="JobsS1">
      <div className="JobsS1P1">
        <TC3L Head={"Job info"} Title={JobName} />
      </div>
      <div className="JobsS1P23">
        <div className="JobsS1P2">
          <JobsS1P2Box Head="Location/" Title={JobLocation} />
          <JobsS1P2Box Head="Employment Type/" Title={JobType} />
          <JobsS1P2Box Head="Department/" Title={JobDepartment} />
        </div>
        <div className="JobsS1P3">
          <button onClick={onScrollToForm}>
            <div className="TFut16PxPCUC JobsS1P3T">fill form</div>
            <div>
              <img src={ArrowBlue} alt="" className="ArrowBlue" />
            </div>
          </button>
        </div>
      </div>
      <div className="JobsSLine"></div>
    </div>
  );
}

function JobsS1P2Box({ Head, Title }) {
  return (
    <>
      <div className="JobsS1P2Box">
        <div className="TFut20PxPC">{Head}</div>
        <div className="TF20PxSC">{Title}</div>
      </div>
    </>
  );
}

function JobsS2({ JobH1Data }) {
  return (
    <div className="JobsS2">
      <div className="TFut24PxPC">About the Role</div>
      <div className="TF20PxSC JobHData">{JobH1Data}</div>
    </div>
  );
}

function JobsS3({ JobH2Data }) {
  return (
    <div className="JobsS3">
      <div className="TFut24PxPC">Responsibilities</div>
      <ul className="TF20PxSC JobHData">
        {JobH2Data.map((item, index) => (
          <div key={index}>
            {Object.entries(item).map(([key, value]) => (
              <li key={key}>{value}</li>
            ))}
          </div>
        ))}
      </ul>
    </div>
  );
}

function JobsS4({ JobH4Data }) {
  return (
    <>
      <div className="JobsS4">
        <div className="TFut24PxPC">Why Join Milky’s Farm?</div>
        <ul className="TF20PxSC JobHData">
          {JobH4Data.map((item, index) => (
            <div key={index}>
              {Object.entries(item).map(([key, value]) => (
                <li key={key}>{value}</li>
              ))}
            </div>
          ))}
        </ul>
      </div>
      <div className="JobsSLine"></div>
    </>
  );
}

function JobsS5() {
  return (
    <>
      <JobsForm />
    </>
  );
}
